import React from "react";
import useImageSize from "../../../../hooks/global/useImageSize";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { ListingSmallImage } from "./ListingSmallImage";

export const ListingCoachImage = () => {
  const listingData = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );
  const [resizedProfileImage] = useImageSize({
    imageUrl: listingData.user.avatarUrl,
    size: 500,
    originalFormat: true,
  });

  return (
    <ListingSmallImage
      image={resizedProfileImage}
      title={listingData.user.name}
    />
  );
};
